function camelToDash(str) {
  return str.replace(/([A-Z])/g, function (match) {
    return "-".concat(match.toLowerCase());
  });
}

export { camelToDash };